/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_AvailableInputs */

const en_cargos_available = /** @type {(inputs: Cargos_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available`)
};

const es_cargos_available = /** @type {(inputs: Cargos_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible`)
};

/**
* | output |
* | --- |
* | "Available" |
*
* @param {Cargos_AvailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_available = /** @type {((inputs?: Cargos_AvailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_AvailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_available(inputs)
	return es_cargos_available(inputs)
});